export enum EFinalidadeEmissaoNFe {
  NFeNormal = 1,
  NFeComplementar = 2,
  NFeAjuste = 3,
  DevolucaoMercadoria = 4,
}
